import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { cardShape } from '@bibliocommons/bc-prop-types';
import './ContentCardType.scss';

export default function ContentCardType({ card, recommendationType }) {
  const slug = card.getIn(['contentType', 'slug'], '');
  const defaultLabel = card.getIn(['contentType', 'label'], '');

  if (slug || defaultLabel) {
    return (
      <div className="cp-content-card-type">
        {recommendationType === 'spotlight' && (
          <span>
            <FormattedMessage id="card_type_spotlight" /> |{' '}
          </span>
        )}
        <FormattedMessage id={`card_type_${slug.replace('-', '_')}`} defaultMessage={defaultLabel} />
      </div>
    );
  }

  return null;
}

ContentCardType.propTypes = {
  card: cardShape.isRequired,
  recommendationType: PropTypes.string.isRequired
};
